import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Login } from './model/login.model';
import { Token } from './model/token.model';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private API = environment.BACKEND;
  private BASE_URL = this.API.BASE_URL;
  private HEADERS = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

  constructor(
    private http: HttpClient,
  ) { }

  login(email: string, password) {
    const login: Login = {
      Email: email,
      Password: password
    };

    return this.http.post<Token>(this.BASE_URL + this.API.LOGIN, JSON.stringify(login), { headers: this.HEADERS })
      .pipe(catchError(this.errorHandler));
  }


  private errorHandler(error: HttpErrorResponse) {
    return throwError(error);
  }
}
